'use strict';
import * as $j_app$002etulz$002etuplez$002e$002dComposition from "./app.tulz.tuplez.-Composition.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1() {
}
export { $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 as $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 };
$c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype = new $j_app$002etulz$002etuplez$002e$002dComposition.$h_Lapp_tulz_tuplez_Composition();
$c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1() {
}
export { $h_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 as $h_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 };
$h_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype = $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype;
$c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype.compose__O__O__O = (function(a, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), a, b);
});
$c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype.decompose__O__T2 = (function(c) {
  return c;
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1, "app.tulz.tuplez.Composition_Pri0$$anon$1", ({
  Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1: 1,
  Lapp_tulz_tuplez_Composition: 1
}));
export { $d_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 as $d_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 };
//# sourceMappingURL=app.tulz.tuplez.-Composition_-Pri0$$anon$1.js.map
